<script>
  import MailtoLink from './MailtoLink.svelte'
  import { staticPath } from './../stores.js';
  
  console.log($staticPath)
</script>

<footer>
  <hr>
  <p class="small"><strong>Feedback, comments, inquiries: </strong><MailtoLink email="taiko@nagatashachu.com" /></p>
  <p class="small">Commissioned by <a href="https://nagatashachu.com">Nagata Shachu Taiko Ensemble</a></p>
  <p class="small">Produced by <a href="https://raadseraj.com">Raad Seraj</a></p>
  <p class="small">Created in collaboration with <a href="https://cohort.rocks">Cohort</a></p>
  <details>
    <summary><h3 class="inline"><small>Full cRediTs</small></h3></summary>
    <dl class="small">
      <dt>Amanda Baker</dt><dd>Quality Assurance & Beta Testing Lead</dd>
      <dt>Vish Hansa</dt><dd>360 Videographer & Editor</dd>
      <dt>Kiyoshi Nagata</dt><dd>360 Sound Recordist & Editor, Project Initiator</dd>
      <dt>Tony Nguyen</dt><dd>Taiko Instructor</dd>
      <dt>Jacob Niedzwiecki</dt><dd>Creative Director & Developer</dd>
      <dt>Raad Seraj</dt><dd>Product Manager & Producer</dd>
      <dt>Andrew Siu</dt><dd>Education & Outreach Coordinator, QA Assistant</dd>
      <dt>Aki Takahashi</dt><dd>Workshop Rhythm Composer, Instructor, Character Designer</dd>
      <dt>Royyan Wijaya</dt><dd>Icon Designer (via the <a href="https://thenounproject.com/roywj/" target="_blank">Noun Project</a>)</dd>
      <dt>Paul D. Hunt, Emre Parlak, Nate Piekos (Blambot)</dt><dd>Font Designers (<a href="https://fonts.google.com/specimen/Major+Mono+Display" target="_blank">Major Mono Display</a>, <a href="https://fonts.google.com/specimen/Source+Sans+Pro">Source Sans Pro</a> and <a href="https://fonts.google.com/specimen/Source+Code+Pro">Source Code Pro</a>, <a href="https://blambot.com/products/crash-landing?">Crash Landing)</a></dd>
    </dl>
  </details>

  <!-- <p class="small">Generously supported by the <a href="https://torontoartscouncil.org">Toronto Arts Council</a>, the <a href="https://torontoartsfoundation.org">Toronto Arts Foundation</a>, and the <a href="https://otf.ca">Ontario Trillium Foundation</a></p> -->
  <div class="funder-logos">
    <img srcset={$staticPath + "/images/tac-logo@1x.png 1x, " + $staticPath + "/images/tac-logo@2x.png 2x"} src={$staticPath + "/images/tac-logo@1x.png"} alt="Toronto Arts Council logo">
    <img srcset={$staticPath + "/images/otf-logo@1x.png 1x, " + $staticPath + "/images/otf-logo@2x.png 2x"} src={$staticPath + "/images/otf-logo@1x.png"} alt="Ontario Trillium Foundation logo">
  </div>
</footer>

<style>
  footer {
    margin-top: 1em;
    padding-bottom: 2em;
  }

  .funder-logos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
  }

  .funder-logos > img {
    margin-top: 2em;
  }

  @media(min-width: 666px){
    .funder-logos > img {
      max-height: 75px;
    }
  }
  
</style>